export default ({ app }) => {
    app.config.globalProperties.$storage = window.localStorage;
};
